import React from "react";
import { ButtonSingle } from "../../../../../widget/common/form/Button";
import AppTranslation from "../../../../../service/app_translation/AppTranslation";
import { RecoverPasswordContextImport } from "../../../../../provider/onboarding/forgot_password/recover_password/RecoverPasswordContextProvider";

const RecoverPasswordButtons = (props: { type?: number | undefined }) => {
  const { submitDetail, processing } = RecoverPasswordContextImport();

  return (
    <ButtonSingle
      handleClick={() => submitDetail()}
      width={300}
      processing={processing}
    >
      {AppTranslation.text("reset_password")}
    </ButtonSingle>
  );
};

export default RecoverPasswordButtons;
